import { render, staticRenderFns } from "./TableMundialWidgetInformador.vue?vue&type=template&id=60453c72&scoped=true&"
import script from "./TableMundialWidgetInformador.vue?vue&type=script&lang=js&"
export * from "./TableMundialWidgetInformador.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialWidgetInformador.vue?vue&type=style&index=0&id=60453c72&prod&lang=css&"
import style1 from "./TableMundialWidgetInformador.vue?vue&type=style&index=1&id=60453c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60453c72",
  null
  
)

export default component.exports